import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCommonStore } from '@/store';
import { ImageComponent } from '../Image';

import { ScAdvantageItem, ScAdvantages } from './styled';

export interface Advantage {
  icon: string;
  text: string;
}

export interface AdvantagesProps {
  advantages: Advantage[];
}

const OFFER_TEXT_PARTS_AMOUNT = 2;

export const Advantages: FC<AdvantagesProps> = ({ advantages }) => {
  const {
    i18n: { language },
  } = useTranslation('common');
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <ScAdvantages>
      {advantages.map(({ icon, text }, idx) => {
        const textArr = text.split('+');
        const isOffer =
          textArr.length === OFFER_TEXT_PARTS_AMOUNT && !isMobileDevice;

        return (
          <ScAdvantageItem isOffer={isOffer} key={idx}>
            <span className="icon">
              <ImageComponent
                alt="advantage"
                height={18}
                src={icon}
                width={18}
              />
            </span>
            <span className={`label ${language.toLowerCase()}`}>
              {isOffer ? (
                <>
                  {textArr[0]} <br /> + {textArr[1]}
                </>
              ) : (
                text
              )}
            </span>
          </ScAdvantageItem>
        );
      })}
    </ScAdvantages>
  );
};
